function replacer(interpolations, _, p1) {
    return interpolations[p1] ? interpolations[p1].toString() : '';
}
/**
 * This regular expression match any string wrapped in `{{}}` allowing spaced before and after the string
 */
const variableSignature = /{{\s*([^{}\s]*)\s*}}/g;
/**
 * Interpolates values in a string following the `{{ VAR }}` format.
 * @internal
 * @param string - String to interpolate
 * @param interpolations - Object with key-values to use in interpolation
 */
export function interpolate(string, interpolations) {
    if (!interpolations || Object.keys(interpolations).length === 0) {
        return string;
    }
    if (typeof string === 'string') {
        return string.replace(variableSignature, replacer.bind(null, interpolations));
    }
    return string.map(s => s.replace(variableSignature, replacer.bind(null, interpolations)));
}
